import { z } from 'zod';

export const ProductLayoutSchema = z.enum([
  'modern', // Boutique / Vestidos
  'technical', // Repuestos / Industrial
  'process', // Trámites / Servicios / Impresiones
  'course', // Educación / Talleres
  'food', // Gastronomía / Menú
  'standard', // Retail general
]);

export type ProductLayout = z.infer<typeof ProductLayoutSchema>;
